module.exports = __webpack_public_path__ + "static/media/logo.aec949ef.svg";